var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkMarkBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 192,
    viewBox: "0 0 339 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.63 0H181.06C186.97 0 191.7 4.7 191.84 10.6V180.44C191.84 186.32 187.12 191.02 181.21 191.02H10.63C4.71 191.02 0 186.32 0 180.44V10.58C0 4.7 4.72 0 10.63 0ZM46.75 94.63C46.75 121.61 68.69 143.6 95.92 143.6C123.15 143.6 145.09 121.61 145.09 94.48C145.09 67.35 122.99 45.66 95.92 45.66C68.85 45.66 46.75 67.65 46.75 94.63Z",
    fill: "#263E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.11 94.49C338.11 120.1 317.26 140.86 291.54 140.86C265.82 140.86 244.97 120.09 244.97 94.49C244.97 68.89 265.82 48.12 291.54 48.12C317.26 48.12 338.11 68.89 338.11 94.49Z",
    fill: "#263E5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkMarkBlue);
export default __webpack_public_path__ + "static/media/work_mark_blue.37175ff4704acde46a30017f7e4e2259.svg";
export { ForwardRef as ReactComponent };